module.exports = __webpack_public_path__ + "static/media/p4_6.b9710634.png";